// QrPatrolLocationModal.tsx
import PropTypes from "prop-types";
import { QRCodeCanvas } from "qrcode.react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useRef } from "react";

const QrActivityLocationModal = ({ show, onCloseClick, data }: any) => {
  const qrRef = useRef<HTMLDivElement>(null);

  const downloadQRCode = () => {
    if (!qrRef.current) return;

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const scale = 3;
    const width = 400 * scale;
    const height = 550 * scale;
    canvas.width = width;
    canvas.height = height;

    ctx.scale(scale, scale);

    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, 400, 550);

    ctx.strokeStyle = "#e5e7eb";
    ctx.lineWidth = 2;
    ctx.strokeRect(10, 10, 380, 530);

    const qrCanvas = qrRef.current.querySelector("canvas");
    if (qrCanvas) {
      const qrSize = 250;
      const qrX = (400 - qrSize) / 2;
      const qrY = 60;

      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(qrCanvas, qrX, qrY, qrSize, qrSize);
    }

    ctx.fillStyle = "#1f2937";
    ctx.textAlign = "center";

    ctx.font = "bold 20px Arial";
    ctx.fillText("LOKASI AKTIVITAS PEKERJAAN", 200, 350);

    ctx.font = "bold 24px Arial";
    ctx.fillText(data?.name || "", 200, 390);

    ctx.font = "14px Arial";
    ctx.fillStyle = "#6b7280";
    ctx.fillText("Scan QR Code untuk aktivitas pekerjaan", 200, 480);

    const link = document.createElement("a");
    link.download = `QR-Aktivitas-${data?.name || "aktivitas"}.png`;
    link.href = canvas.toDataURL("image/png", 1.0);
    link.click();
  };

  return (
    <Modal
      size="md"
      fade={true}
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
    >
      <ModalHeader className="border-0 pb-0" toggle={onCloseClick}>
        <div className="text-grey">
          <h5 className="mb-1">QR Code Lokasi Aktivitas Pekerjaan</h5>
        </div>
      </ModalHeader>
      <ModalBody className="pt-4 pb-4">
        <div ref={qrRef} className="text-center">
          <div
            className="d-inline-block p-4 mb-3"
            style={{
              background: "white",
              borderRadius: "16px",
              boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
              border: "1px solid #e5e7eb",
            }}
          >
            <QRCodeCanvas
              value={data?._id || ""}
              title={data?.name}
              size={200}
              bgColor={"#ffffff"}
              fgColor={"#1f2937"}
              level={"H"}
            />
          </div>

          <div
            className="mx-auto p-3"
            style={{
              maxWidth: "300px",
              background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
              borderRadius: "12px",
              border: "1px solid #e5e7eb",
            }}
          >
            <div className="mb-2">
              <span
                className="badge"
                style={{
                  background:
                    "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
                  fontSize: "0.75rem",
                  padding: "0.35rem 0.75rem",
                }}
              >
                LOKASI AKTIVITAS PEKERJAAN
              </span>
            </div>
            <h5 className="mb-2 fw-bold" style={{ color: "#1f2937" }}>
              {data?.name}
            </h5>
            {data?.kategori && (
              <div
                className="d-flex align-items-center justify-content-center gap-2"
                style={{ fontSize: "0.95rem", color: "#4b5563" }}
              >
                <i className="las la-users"></i>
                <span className="fw-semibold">{data?.kategori}</span>
              </div>
            )}
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="border-0 pt-0">
        <button
          type="button"
          className="btn btn-light waves-effect waves-light material-shadow-none btn-sm"
          onClick={onCloseClick}
        >
          Tutup
        </button>
        <button
          type="button"
          className="btn waves-effect waves-light material-shadow-none btn-sm"
          style={{
            background: "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
            color: "white",
            border: "none",
          }}
          onClick={downloadQRCode}
        >
          <i className="ri-download-2-line me-1"></i>
          Download QR Code
        </button>
      </ModalFooter>
    </Modal>
  );
};

QrActivityLocationModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  data: PropTypes.any,
};

export default QrActivityLocationModal;
